
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/b12b9a0ca9e4c1ccf1aa04e1d4b67e89/0e7ea50cbf065285b61824de3ee6f1ab.png"
          alt="Property damage inspection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-shield-check-line text-white text-lg"></i>
              <span className="text-white text-sm font-semibold">25+ Years Combined Experience</span>
            </div>

            <h1 className="text-5xl lg:text-7xl font-extrabold text-white leading-tight mb-6" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>
              Protect Your Property. Protect Your Wallet. Get the Settlement You Deserve.
            </h1>

            <p className="text-lg text-white/90 leading-relaxed mb-8 max-w-2xl">
              Claim It Assist helps homeowners and business owners in New Jersey, Pennsylvania, and Maryland get fair, accurate, and maximized insurance settlements. We work for YOU — never the insurance company.
            </p>

            <button
              onClick={scrollToContact}
              className="bg-[#FF6B35] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#ff5722] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap"
            >
              Request Free Claim Review
            </button>
          </div>

          <div className="lg:col-span-2 hidden lg:block">
            <div className="space-y-4">
              <div className="bg-white rounded-2xl p-6 shadow-xl transform hover:scale-105 transition-transform">
                <div className="text-5xl font-bold text-[#1e3a5f] mb-2">80%</div>
                <div className="text-sm text-gray-600">Have Hidden Damage</div>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-xl transform hover:scale-105 transition-transform ml-8">
                <div className="text-5xl font-bold text-[#FF6B35] mb-2">$23K</div>
                <div className="text-sm text-gray-600">Average Increase</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
